import { runtimeEnv } from 'config/runtimeEnv';
import { setCurrentUser } from 'utils/utils';
import { API_ENDPOINT } from './Api';
import requestInstance from './Request';

let env = runtimeEnv('B2B_API_BASE_URL');

export const dutyTypeApi = async (dutyType) => {
  let url = '';
  const page = dutyType?.page === 0 || dutyType?.page ? dutyType?.page + 1 : 1;

  url = `${env}${API_ENDPOINT.DutyType.api + '?page=' + page + '&pageSize=' + dutyType?.page}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};
